import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "data-cy": "core-header"
    }
  }, [_vm.headerBG || _vm.headline || _vm.subtitle || _vm.$slots['headline'] ? _c(VRow, {
    staticClass: "pb-0 mx-0",
    staticStyle: {
      "min-width": "0",
      "margin-bottom": "0"
    }
  }, [_c(VCol, {
    staticClass: "pa-0"
  }, [_vm.headerBG ? _c(VParallax, {
    staticClass: "top-element-bg",
    attrs: {
      "height": "190",
      "src": _vm.headerBG
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.$slots['headline'] ? _c('h2', {
    staticClass: "pl-3 pr-3 header-text text-truncate",
    style: _vm.styles
  }, [_vm._t("headline")], 2) : _c('h2', {
    staticClass: "pl-3 pr-3 header-text text-truncate",
    style: _vm.styles
  }, [_vm._v("\n            " + _vm._s(_vm.headline) + "\n          ")]), _vm.showBetaBadge ? _c(VBadge, {
    staticClass: "mr-3 ml-2",
    attrs: {
      "content": typeof _vm.showBetaBadge === 'string' ? _vm.showBetaBadge : 'BETA',
      "color": "error"
    }
  }) : _vm._e()], 1), _vm.subtitle ? _c('div', {
    staticClass: "pl-3 pr-3 header-text text-truncate",
    style: _vm.styles
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]) : _c('div', {
    staticClass: "pa-4 page-header-bg top-element-bg",
    attrs: {
      "height": "142"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_vm.$slots['headline'] ? _c('h2', {
    staticClass: "pl-3 pr-3 header-text text-truncate",
    style: _vm.styles
  }, [_vm._t("headline")], 2) : _c('h2', {
    class: `pl-3 pr-3 header-text text-truncate`,
    style: _vm.styles
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_vm.templateContext && (_vm.hasUnsyncedChanges || _vm.itemIsChanged) ? _c('i', {
    staticClass: "fas fa-circle fa-xs",
    staticStyle: {
      "color": "orange",
      "margin-right": "8px"
    },
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.templateHasUnsyncedChanges')
    }
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.headline) + "\n            ")])]), _vm.showBetaBadge ? _c(VBadge, {
    staticClass: "mr-3 ml-2",
    attrs: {
      "content": typeof _vm.showBetaBadge === 'string' ? _vm.showBetaBadge : 'BETA',
      "color": "error"
    }
  }) : _vm._e()], 1), _vm.$slots['subtitle-slot'] ? _c('div', {
    staticClass: "pl-3 pr-3 header-text text-truncate spec-width",
    style: _vm.styles
  }, [_vm._t("subtitle-slot")], 2) : _vm.subtitle ? _c('div', {
    staticClass: "pl-3 pr-3 header-text text-truncate spec-width",
    style: _vm.styles
  }, [_vm._v("\n          " + _vm._s(_vm.subtitle) + "\n        ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm.displayButtons || _vm.$slots.buttons ? _c('div', _vm._b({}, 'div', _vm.actionBoxClass, false), [_c('div', {
    class: `px-2 ${_vm.actionBoxGradientClass}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._t("buttons", function () {
    return _vm._l(_vm.displayButtons, function (item, i) {
      return _c('span', {
        key: i
      }, [_vm._t("singleButton", function () {
        return [item.title && !_vm.isMobile ? _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "loading": item.isLoading || _vm.isSaving,
            "disabled": item.type === 'submit' && !_vm.formIsValid || !_vm.buttonHasValidState(i) || _vm.isSaving || _vm.cloading,
            "title": item.tooltip,
            "href": item.href,
            "target": item.href && item.target,
            "prepend-icon": item.icon
          },
          on: {
            "click": function ($event) {
              return _vm.handleButtonClick(item);
            }
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")]) : _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "loading": item.isLoading || _vm.isSaving,
            "disabled": item.type === 'submit' && !_vm.formIsValid || !_vm.buttonHasValidState(i) || _vm.isSaving || _vm.cloading,
            "title": item.tooltip,
            "href": item.href,
            "target": item.href && item.target,
            "prepend-icon": item.icon
          },
          on: {
            "click": function ($event) {
              return _vm.handleButtonClick(item);
            }
          }
        })];
      }, {
        "button": item
      })], 2);
    });
  }, {
    "buttons": _vm.displayButtons
  }), _vm._t("buttons-after")], 2)]) : _vm._e(), _vm.isLoading || _vm.loader && _vm.cloading ? _c(VProgressLinear, {
    attrs: {
      "indeterminate": "",
      "color": _vm.color,
      "height": "3"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "3px"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };